import {Injectable} from '@angular/core';
import {AuthenticationService} from './shared/services/authentication/authentication.service';
import {SessionStorageEnum} from './shared/enums/sessionStorage.enum';
import {Router} from '@angular/router';
import {RouteUtils} from "./utils/route.utils";
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {
  }

  async init(): Promise<void> {
    await this.loadScriptRecaptcha();
    if (environment.keepSession) {
      const currentUrl = window.location.pathname.replace(/^\//, '');
      const rawUserAuth = sessionStorage.getItem(SessionStorageEnum.USER_AUTH);

      if (currentUrl === RouteUtils.PAGES.LOGIN) await this.redirectToLogin();

      if (rawUserAuth) {
        try {
          const userAuth = JSON.parse(rawUserAuth);

          return new Promise<void>((resolve) => {

            this.authService.login(
              userAuth,
              () => {
                this.router.navigateByUrl(currentUrl).then(() => resolve());
              },
              () => {
                this.authService.removeAuthSessionStorage();
                this.router.navigateByUrl(RouteUtils.PAGES.LOGIN).then(() => resolve());
              }
            );
          });
        } catch {
          await this.redirectToLogin();
        }
      } else {
        await this.redirectToLogin();
      }
    } else {
      await this.redirectToLogin();
    }
  }

  private async redirectToLogin(): Promise<void> {
    this.authService.removeAuthSessionStorage();
    return this.router.navigateByUrl(RouteUtils.PAGES.LOGIN).then(() => Promise.resolve());
  }

  private loadScriptRecaptcha(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.getElementById('recaptcha-script')) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.id = 'recaptcha-script';
      script.src = 'https://www.google.com/recaptcha/enterprise.js?render=' + environment.reCaptchaKey;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Erro ao carregar reCAPTCHA'));
      document.body.appendChild(script);
    });
  }
}
